export default [
  {
    path: "/count",
    props: true,
    component: () => import("../Main.vue")
  }
]
